/* eslint-disable react/no-array-index-key */
import React from "react";

import { classNames } from "repoV2/utils/common/render/classNames";
import { IBillRows } from "./IBillRows";

export const BillRows = ({ styles, billRowsData }: IBillRows.IProps) => {
    return (
        <div className={styles.billContainer}>
            {billRowsData.map((row, index) => {
                if (row.hide) return null;
                if (row.rowType === "divider")
                    return <hr className={styles.billDivider} key={index} />;

                return (
                    <div
                        key={index}
                        className={classNames(
                            styles.billLine,

                            row?.options?.isCollapsible && styles.collapsible,

                            row?.options?.onClick && styles.collapseToggler,

                            row?.options?.bold && styles.boldRow,

                            row.options?.coupleWithPreviousRow &&
                                styles.coupleWithPreviousRow,

                            row?.options?.className
                        )}
                        {...(row?.options?.onClick && {
                            onClick: row?.options?.onClick,
                        })}
                        {...(row?.options?.tooltip && {
                            title: row?.options?.tooltip,
                        })}
                    >
                        <div className={styles.billItem}>{row.renderLeft}</div>
                        <div className={styles.billItem}>{row.renderRight}</div>
                    </div>
                );
            })}
        </div>
    );
};
